"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "component__Wrapper",
  componentId: "sc-9bxleg-0"
})(["margin-top:15px;"]);

var FilterStrings = function FilterStrings(_ref) {
  var filter = _ref.filter,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["filter", "onChange"]);

  var _filter$value;

  var options = (0, _react.useMemo)(function () {
    return filter.config.values.map(function (value) {
      return {
        label: value === '' ? '(empty string)' : value,
        value: value
      };
    });
  }, [filter]);
  return _react["default"].createElement(Wrapper, null, _react["default"].createElement(_reactSelect["default"], _extends({
    isMulti: true,
    placeholder: "Select values",
    name: "filter-string-values-".concat(filter.id),
    value: ((_filter$value = filter.value) !== null && _filter$value !== void 0 ? _filter$value : []).map(function (value) {
      return options.find(function (option) {
        return option.value === value;
      });
    }),
    options: options,
    onChange: function onChange(selectedOptions) {
      return _onChange(selectedOptions.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }));
    }
  }, rest)));
};

FilterStrings.propTypes = {
  filter: _propTypes["default"].shape({
    column: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    operation: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
    config: _propTypes["default"].object.isRequired
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = FilterStrings;
exports["default"] = _default;